import React, { useState } from "react";
import "./CopyPopup.scss";
import shareIcon from "../../../assets/images/share_icon.svg";
import linkIcon from "../../../assets/images/Link.svg";
import closeIcon from "../../../assets/images/close_white.svg";
import closeBlueIcon from "../../../assets/images/close_blue.svg";

export default function CopyPopup({ sourceImage, articleHeading, sourceLink }) {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(sourceLink);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="copy_popup_wrapper">
      <button
        className="copy_open_popup_btn"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <div className="news_share_icon">
          <img src={shareIcon} alt="share" />
        </div>
      </button>

      {isOpen && (
        <div className="copy_popup_overlay" onClick={() => setIsOpen(false)}>
          <div className="copy_popup_card" onClick={(e) => e.stopPropagation()}>
            <div className="copy_popup_card_header">
              <div className="copy_heading_container">
                <img src={sourceImage} alt="source" />

                <h2 className="copy_link_heading">{articleHeading}</h2>
              </div>

              <div
                className="copy_popup_close_btn"
                onClick={() => setIsOpen(false)}
              >
                <img src={closeIcon} alt="x" className="cross_desktop_image" />
                <img
                  src={closeBlueIcon}
                  alt="mobile"
                  className="cross_mobile_image"
                />
              </div>
            </div>

            <div className="copy_popup_card_body">
              <span className="copy_link_icon">
                <img src={linkIcon} alt="Link" />
              </span>
              <span className="copy_link_text">
                {sourceLink.slice(0, sourceLink.length)}...
              </span>
              <button
                className={`copy_btn ${copied ? "copied" : ""}`}
                onClick={handleCopy}
              >
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
